// extracted by mini-css-extract-plugin
export default {"rejection":"rejection--yqMbb","warning":"warning--ROHe0","warningText":"warningText--g4jEd"};